export default __webpack_public_path__ + "static/media/Dubai Islamic Cheque.e09df734.png";